import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import SearchTable from "../../../components/SearchTable";
import EmptyData from "../../../components/EmptyData";
import TableFilter from "../../../components/TableFilter";
import PaginationComponent from "../../../components/Pagination";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { productPublicContext } from "../../../context/PublicContext/ProductPublicContext/ProductPublicContext";
import { convertRoleToPath } from "../../../utils/enum";
import { hostname } from "../../../services/configServices/config";

const ProductsPublic = () => {
  const { pathname } = useLocation();

  const {
    products,
    setProducts,
    filter,
    setFilter,
    sort,
    setSort,
    type,
    setType,
    pageCount,
    pageNumber,
    setPageNumber,
    itemsCount,
    setItemsCount,
    handleGetProducts,
  } = useContext(productPublicContext);

  useEffect(() => {
    handleGetProducts();
    return () => {
      setProducts([]);
    };
  }, [sort, pathname, type, pageNumber, itemsCount]);

  return (
    <>
      <SiteTitle title="محصولات" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
        productType={type}
        setProductType={setType}
      />

      <div className="card h-100 p-0 radius-12">
        <SearchTable
          filter={filter}
          setFilter={setFilter}
          onSearch={handleGetProducts}
        />
        <div className="card-body p-24">
          {isEmpty(products) ? (
            <EmptyData title="محصولی برای نمایش یافت نشد" />
          ) : (
            <>
              <div className="row gy-4">
                {products?.map((_item) => (
                  <div
                    className="col-xxl-3 col-lg-4 col-sm-6 col-12"
                    key={_item._id}
                  >
                    <ProductCard product={_item} />
                  </div>
                ))}
              </div>

              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductsPublic;

export const ProductCard = ({ product }) => {
  const auth = useSelector((state) => state.auth);

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden">
      <div className="card-body p-24">
        <Link
          to={`${
            auth?.role ? `/${convertRoleToPath(auth?.role)}` : ""
          }/product/${product?._id}/product`}
          className="w-100 max-h-194-px radius-8 overflow-hidden"
        >
          <img
            src={
              product?.picture
                ? `${hostname}${product?.picture}`
                : "/assets/images/empty-image.png"
            }
            alt=""
            className="w-100 h-100 object-fit-cover"
          />
        </Link>
        <div className="mt-20">
          <div className="d-flex align-items-center gap-6 justify-content-between flex-wrap mb-16">
            <Link
              to={`${
                auth?.role ? `/${convertRoleToPath(auth?.role)}` : ""
              }/product/${product?._id}/product`}
              className="px-20 py-6 bg-neutral-100 rounded-pill bg-hover-neutral-300 text-neutral-600 fw-medium"
            >
              {product?.code}
            </Link>
            <div className="d-flex align-items-center gap-8 text-neutral-500 fw-medium">
              {product?.price > 0 ? (
                <span>
                  <ConvertCurrency price={product?.price} />
                  <Currency />
                </span>
              ) : (
                <span className="fw-bold">پس از بررسی مدیریت</span>
              )}
            </div>
          </div>
          <h6 className="mb-16">
            <Link
              to={`${
                auth?.role ? `/${convertRoleToPath(auth?.role)}` : ""
              }/product/${product?._id}/product`}
              className="text-line-2 text-hover-primary-600 text-xl transition-2"
            >
              {product?.title}
            </Link>
          </h6>
          <h6 className="mb-16 text-line-2 text-sm transition-2">
            {product?.category?.parent && (
              <>
                <Link
                  className="text-hover-primary-600"
                  to={`${
                    auth?.role ? `/${convertRoleToPath(auth?.role)}` : ""
                  }/category/${product?.category?.parent?._id}/category`}
                >
                  {product?.category?.parent?.title}
                </Link>
                {" / "}
              </>
            )}
            <Link
              className="text-hover-primary-600"
              to={`${
                auth?.role ? `/${convertRoleToPath(auth?.role)}` : ""
              }/product/${product?.category?._id}/category`}
            >
              {product?.category?.title}
            </Link>
          </h6>
          <p className="text-line-3 text-neutral-500">{product?.description}</p>
          <Link
            to={`${
              auth?.role ? `/${convertRoleToPath(auth?.role)}` : ""
            }/product/${product?._id}/product`}
            className="d-flex align-items-center gap-8 fw-semibold text-neutral-900 text-hover-primary-600 transition-2"
          >
            مشاهده
            <i className="ri-arrow-left-double-line text-xl d-flex line-height-1" />
          </Link>
        </div>
      </div>
    </div>
  );
};
